import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { COMPANY } from "@/data/v2";

export const StickyCall = () => (
  <motion.a
    href={`tel:${COMPANY.phone}`}
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.8, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    className="fixed bottom-5 right-5 z-[90] group inline-flex items-center gap-2.5 bg-mh2-terra hover:bg-mh2-terraHover text-white font-semibold pl-4 pr-5 py-3.5 rounded-full shadow-xl shadow-mh2-terra/30 transition-colors"
    data-testid="sticky-call-btn"
    aria-label={`Appeler MH Étanchéité au ${COMPANY.phoneDisplay}`}
  >
    <span className="relative flex items-center justify-center">
      <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 opacity-75 animate-ping" />
      <span className="relative inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/20">
        <Phone size={18} className="group-hover:rotate-12 transition-transform" />
      </span>
    </span>
    <span className="hidden sm:inline whitespace-nowrap">{COMPANY.phoneDisplay}</span>
  </motion.a>
);
